// FASE 05 — Cadastros Gerais (especificação de 11/08/2026, plano de 23/09/2026).
// Cadastros da Gerência que migraram do MOF antigo: regras do legado, layout do gabarito e sem os
// recursos que a especificação retirou (Comum, Unidade e Preço da ClasseId, coluna Ativo dos Prenativos).
import { useState } from "react";
import { CheckCircle, Cancel } from "@mui/icons-material";
import { CustomButton } from "components/CustomButtom";
import { listarTodos } from "services/modules/cadastrosGerais";
import { PaginaCadastroGeral } from "./PaginaCadastroGeral";
import { ModalTemperas } from "./Ligas/ModalTemperas";

export const Unidades = () => (
  <PaginaCadastroGeral
    titulo="CADASTRO DE UNIDADES"
    rotulo="Unidades"
    tituloListagem="Listagem de unidades do MOF"
    tituloModal="Cadastro de unidade"
    endpoint="/UnidadeItemEmbalagem"
    campoId="idUnidadeItemEmbalagem"
    colunas={[
      { campo: "sigla", titulo: "Sigla", flex: 0.4, filtro: true },
      { campo: "descricao", titulo: "Descrição" },
    ]}
    campos={[
      { nome: "sigla", rotulo: "Sigla", tipo: "texto", obrigatorio: true, maxLength: 5 },
      { nome: "descricao", rotulo: "Descrição", tipo: "texto", obrigatorio: true },
    ]}
  />
);

export const TiposVidro = () => (
  <PaginaCadastroGeral
    titulo="CADASTRO DE TIPOS DE VIDRO"
    rotulo="Tipos de Vidro"
    tituloListagem="Listagem de tipos de vidro do MOF"
    tituloModal="Cadastro de tipo de vidro"
    endpoint="/TipoVidro"
    campoId="idTipoVidro"
    colunas={[
      { campo: "codigo", titulo: "Código", flex: 0.5, filtro: true },
      { campo: "descricao", titulo: "Descrição" },
    ]}
    campos={[
      { nome: "codigo", rotulo: "Código", tipo: "texto", obrigatorio: true, maxLength: 450 },
      { nome: "descricao", rotulo: "Descrição", tipo: "texto", obrigatorio: true },
    ]}
  />
);

export const TiposAcabamento = () => (
  <PaginaCadastroGeral
    titulo="CADASTRO DE TIPOS DE ACABAMENTO"
    rotulo="Tipos de Acabamento"
    tituloListagem="Listagem de tipos de acabamento do MOF"
    tituloModal="Cadastro de tipo de acabamento"
    endpoint="/TipoAcabamento"
    campoId="idTipoAcabamento"
    colunas={[{ campo: "descricao", titulo: "Nome do acabamento", filtro: true }]}
    campos={[{ nome: "descricao", rotulo: "Nome do acabamento", tipo: "texto", obrigatorio: true, maxLength: 450 }]}
  />
);

export const TiposTecido = () => (
  <PaginaCadastroGeral
    titulo="CADASTRO DE TIPOS DE TECIDO"
    rotulo="Tipos de Tecido"
    tituloListagem="Listagem de tipos de tecido do MOF"
    tituloModal="Cadastro de tipo de tecido"
    endpoint="/TipoTecido"
    campoId="idTipoTecido"
    colunas={[
      { campo: "descricao", titulo: "Nome do tipo de tecido", filtro: true },
      {
        campo: "ativo",
        titulo: "Ativo",
        flex: 0.2,
        render: (linha) => (linha.ativo ? <CheckCircle color="success" /> : <Cancel color="disabled" />),
      },
    ]}
    campos={[
      { nome: "descricao", rotulo: "Nome do tipo de tecido", tipo: "texto", obrigatorio: true, maxLength: 200 },
      { nome: "ativo", rotulo: "Ativo", tipo: "interruptor", valorPadrao: true },
    ]}
  />
);

// Plano 02/10/2026 (Frente 13): ClassesIds ganhou página própria no padrão do Cadastro de Projetistas.
export { ClassesIds } from "./ClassesIds";

export const Cores = () => (
  <PaginaCadastroGeral
    titulo="CADASTRO DE CORES"
    rotulo="Cores"
    tituloListagem="Listagem de cores do MOF"
    tituloModal="Cadastro de cor"
    endpoint="/CorMaterial"
    campoId="idCorMaterial"
    colunas={[
      { campo: "descricao", titulo: "Nome da cor", filtro: true },
      { campo: "material", titulo: "Tipos de material" },
    ]}
    campos={[
      { nome: "descricao", rotulo: "Nome da cor", tipo: "texto", obrigatorio: true, maxLength: 40 },
      { nome: "tiposMaterial", rotulo: "Selecione os tipos de materiais", tipo: "tiposMaterial" },
    ]}
  />
);

export const Grupos = () => (
  <PaginaCadastroGeral
    titulo="CADASTRO DE GRUPOS"
    rotulo="Grupos"
    tituloListagem="Listagem de grupos do MOF"
    tituloModal="Cadastro de grupo"
    endpoint="/GrupoMaterial"
    campoId="idGrupoMaterial"
    colunas={[
      { campo: "codigo", titulo: "Código", flex: 0.5, filtro: true },
      { campo: "descricao", titulo: "Descrição" },
      { campo: "material", titulo: "Tipos de material" },
    ]}
    campos={[
      { nome: "codigo", rotulo: "Código", tipo: "texto", obrigatorio: true, maxLength: 40 },
      { nome: "descricao", rotulo: "Descrição", tipo: "texto", obrigatorio: true },
      { nome: "tiposMaterial", rotulo: "Selecione os tipos de materiais", tipo: "tiposMaterial" },
    ]}
  />
);

// Opções do legado (site/src/pages/Prenativo): a sigla é gravada em Prenativos.PrenativoSigla.
const TIPOS_PRENATIVO = [
  { value: "S", label: "SÓLIDO" },
  { value: "SBRUTO", label: "SÓLIDO BRUTO" },
  { value: "T", label: "TUBULAR" },
  { value: "TBRUTO", label: "TUBULAR BRUTO" },
  { value: "U", label: "USINADO" },
  { value: "US", label: "USINADO SÓLIDO" },
];

export const Prenativos = () => (
  <PaginaCadastroGeral
    titulo="CADASTRO DE PRENATIVOS"
    rotulo="Prenativos"
    tituloListagem="Listagem de prenativos do MOF"
    tituloModal="Cadastro de prenativo"
    endpoint="/Prenativo"
    campoId="idPrenativo"
    colunas={[
      { campo: "codigo", titulo: "Código do prenativo", flex: 0.6, filtro: true },
      { campo: "descricao", titulo: "Descrição" },
      { campo: "unidade", titulo: "Unidade", flex: 0.3 },
      {
        campo: "tipo",
        titulo: "Tipo",
        flex: 0.4,
        // Registros antigos com sigla fora da lista (ex.: ISIS) aparecem como estão.
        render: (linha) => TIPOS_PRENATIVO.find((t) => t.value === linha.tipo)?.label ?? linha.tipo,
      },
    ]}
    campos={[
      { nome: "codigo", rotulo: "Código do prenativo", tipo: "texto", obrigatorio: true, maxLength: 450 },
      { nome: "descricao", rotulo: "Descrição do prenativo", tipo: "texto", obrigatorio: true },
      {
        nome: "idUnidadeItemEmbalagem",
        rotulo: "Unidade do prenativo",
        tipo: "selecao",
        obrigatorio: true,
        carregarOpcoes: async () =>
          (await listarTodos<any>("/UnidadeItemEmbalagem")).map((u) => ({
            value: u.idUnidadeItemEmbalagem,
            label: u.descricao ? `${u.sigla} — ${u.descricao}` : u.sigla,
          })),
      },
      { nome: "tipo", rotulo: "Tipo do prenativo", tipo: "selecao", obrigatorio: true, opcoes: TIPOS_PRENATIVO },
    ]}
  />
);

export const Ligas = () => {
  const [temperasAberto, setTemperasAberto] = useState(false);
  const [versao, setVersao] = useState(0);

  return (
    <>
      <PaginaCadastroGeral
        titulo="CADASTRO DE LIGAS E TÊMPERAS"
        rotulo="Ligas e Têmperas"
        tituloListagem="Listagem de ligas e têmperas do MOF"
        tituloModal="Cadastro de liga"
        endpoint="/Liga"
        campoId="idLiga"
        versaoDados={versao}
        acoesCabecalho={
          // Plano 05/10/2026 (Frente 5): mesmo tamanho do CADASTRAR (CustomButton, 240px em md+, 100% abaixo).
          <CustomButton
            variant="outlined"
            onClick={() => setTemperasAberto(true)}
            sx={{ width: { xs: "100%", md: 240 } }}
          >
            Têmperas
          </CustomButton>
        }
        colunas={[
          { campo: "descricao", titulo: "Liga", filtro: true },
          { campo: "tempera", titulo: "Têmpera", flex: 0.6 },
          { campo: "elasticidade", titulo: "Elasticidade", flex: 0.5 },
          { campo: "tensaoMaxima", titulo: "Tensão Máxima", flex: 0.5 },
        ]}
        campos={[
          { nome: "descricao", rotulo: "Liga", tipo: "texto", obrigatorio: true },
          // Plano 02/10/2026 (Frente 8, P7): têmpera obrigatória; elasticidade e tensão opcionais
          // (vazio grava 0 no backend).
          {
            nome: "idTempera",
            rotulo: "Têmpera",
            tipo: "selecao",
            obrigatorio: true,
            carregarOpcoes: async () =>
              (await listarTodos<any>("/Tempera")).map((t) => ({ value: t.idTempera, label: t.descricao })),
          },
          { nome: "elasticidade", rotulo: "Elasticidade", tipo: "numero" },
          { nome: "tensaoMaxima", rotulo: "Tensão Máxima", tipo: "numero" },
        ]}
      />
      <ModalTemperas
        aberto={temperasAberto}
        onFechar={() => {
          setTemperasAberto(false);
          // A listagem mostra a descrição da têmpera; recarrega se ela foi alterada.
          setVersao((v) => v + 1);
        }}
      />
    </>
  );
};
